import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { src: String }
  static targets = ["poster", "video"]

  connect() {


    console.log('connected')
    
    // 카드 안 개별 플레이어 엘리먼트 참조
    this.videoEl = this.hasVideoTarget ? this.videoTarget : null

    // 다른 카드가 재생 중이면 정지하도록 커스텀 이벤트 리스너
    this._onGlobalPause = (e) => {
      if (this.videoEl && e.detail?.except !== this.videoEl) {
        try { this.videoEl.pause() } catch (_) {}
      }
    }
    window.addEventListener("segment:pause-others", this._onGlobalPause)
  }

  disconnect() {
    window.removeEventListener("segment:pause-others", this._onGlobalPause)
    if (this._onTimeUpdate && this.videoEl) {
      this.videoEl.removeEventListener("timeupdate", this._onTimeUpdate)
    }
  }

  play() {
    // 1) 포스터(이미지)인 경우: 비디오 엘리먼트로 교체 후 재생
    if (!this.videoEl && this.hasPosterTarget) {
      if (!this.srcValue) return

      // 비디오 노드 생성
      const video = document.createElement("video")
      video.src = this.srcValue
      video.setAttribute("playsinline", "true")
      video.setAttribute("preload", "metadata")
      video.muted = true
      video.controls = true
      video.className = this.posterTarget.className // 동일 스타일 적용

      // 포스터 자리에 교체
      this.posterTarget.replaceWith(video)
      this.videoEl = video
    }

    if (!this.videoEl) return

    // 2) 재생 전 다른 카드 일시정지 브로드캐스트
    const evt = new CustomEvent("segment:pause-others", { detail: { except: this.videoEl } })
    window.dispatchEvent(evt)

    // 3) 처음부터 재생
    try {
      this.videoEl.currentTime = 0
    } catch (_) {}
    // iOS 등 호환을 위해 play는 약간 지연 호출
    requestAnimationFrame(() => {
      this.videoEl.play().catch(() => {
        // 자동재생 차단 시(드물지만) muted 유지 + 유저가 한 번 더 누르면 재생됨
      })
    })
  }
}
